import { render, staticRenderFns } from "./PersonalChart.vue?vue&type=template&id=3bfa5c00&scoped=true&"
import script from "./PersonalChart.vue?vue&type=script&lang=js&"
export * from "./PersonalChart.vue?vue&type=script&lang=js&"
import style0 from "./PersonalChart.vue?vue&type=style&index=0&id=3bfa5c00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa5c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle})
